export const coreSubjectsTrackerFilters = [
  {
    text: "Operating Systems",
    domainFilter: "operating-systems",
    id: 1,
    lock: false,
  },
  {
    text: "OOPs",
    domainFilter: "oops",
    id: 2,
    lock: false,
  },
  {
    text: "Computer Networks",
    domainFilter: "computer-networks",
    id: 3,
    lock: false,
  },
  {
    text: "DBMS",
    domainFilter: "dbms",
    id: 4,
    lock: false,
  }
];
